<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="title"
    width="520px"
    :close-on-click-modal="false"
    @closed="resetForm"
  >
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="90px" size="mini">
      <el-form-item label="上传方式" prop="uploadMode">
        <el-radio-group v-model="formData.uploadMode">
          <el-radio label="add">新增</el-radio>
          <el-radio label="replace">替换</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="showModel" label="上传型号" prop="modelId">
        <el-select
          v-model="formData.modelId"
          filterable
          allow-create
          default-first-option
          clearable
          placeholder="请选择或输入上传型号"
          style="width: 100%"
        >
          <el-option
            v-for="item in modelOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="选择图片" prop="files">
        <el-upload
          action=""
          :auto-upload="false"
          multiple
          :show-file-list="true"
          :file-list="fileList"
          accept=".jpg,.jpeg,.png"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
        >
          <el-button size="mini" type="primary">上传本地图片</el-button>
          <div slot="tip" class="el-upload__tip">支持多选，仅支持 JPG、PNG 格式</div>
        </el-upload>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button size="mini" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import mockService from '../../mockService'

const MANUAL_MODEL_SUFFIX = '\u3010\u624b\u52a8\u3011'

export default {
  name: 'MaterialUploadDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '上传图片'
    },
    showModel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modelLoading: false,
      modelOptions: [],
      fileList: [],
      formData: {
        uploadMode: 'add',
        modelId: ''
      },
      rules: {
        uploadMode: [
          { required: true, message: '请选择上传方式', trigger: 'change' }
        ],
        modelId: [
          { required: true, message: '请选择或输入上传型号', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible (val) {
      if (val && this.showModel) {
        this.fetchModelOptions()
      }
    }
  },
  methods: {
    fetchModelOptions () {
      this.modelLoading = true
      mockService.searchModelOptions().then(res => {
        this.modelOptions = res.data || []
      }).finally(() => {
        this.modelLoading = false
      })
    },
    handleFileChange (file, fileList) {
      const name = (file.raw && file.raw.name) || file.name || ''
      const ext = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (['jpg', 'jpeg', 'png'].indexOf(ext) === -1) {
        this.$message.error('仅支持 JPG、PNG 格式')
        this.fileList = fileList.filter(item => {
          const currentName = (item.raw && item.raw.name) || item.name || ''
          const currentExt = currentName.substring(currentName.lastIndexOf('.') + 1).toLowerCase()
          return ['jpg', 'jpeg', 'png'].includes(currentExt)
        })
        return
      }
      this.fileList = fileList
    },
    handleFileRemove (file, fileList) {
      this.fileList = fileList
    },
    handleConfirm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        if (!this.fileList.length) {
          this.$message.error('请先选择图片')
          return
        }
        const modelValue = (this.formData.modelId || '').trim()
        const matchedModel = this.modelOptions.find(item => item.value === modelValue || item.label === modelValue)
        const isManualModel = this.showModel && !!modelValue && !matchedModel
        const finalModelValue = isManualModel ? `${modelValue}${MANUAL_MODEL_SUFFIX}` : (modelValue || '')
        this.$emit('confirm', {
          uploadMode: this.formData.uploadMode,
          modelId: finalModelValue,
          modelName: isManualModel ? finalModelValue : ((matchedModel && matchedModel.label) || ''),
          files: this.fileList.map(item => (item.raw ? item : { raw: item }))
        })
      })
    },
    resetForm () {
      this.formData = {
        uploadMode: 'add',
        modelId: ''
      }
      this.fileList = []
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate()
      }
    }
  }
}
</script>
